import useTableStore from "../../../../store/table";

// context
import { useTableId } from "../../../../contexts/TableId";

import { Radio, RadioGroup, FormControlLabel } from '@mui/material';

import { strToBool, boolToStr } from "../../../util";

const BooleanOptions = ({ id, labels = ["True", "False"] }) => {
  const tableId = useTableId();
  const handleFilter = useTableStore(state => state.handleTableFilter);
  const value = useTableStore(state => state.tableFilters[tableId]?.[id]?.$eq);

  const handleChange = (e) => {
    handleFilter(e, tableId, id, "$eq", "boolean");
  }

  return (
    <RadioGroup
      value={boolToStr(value)}
      onChange={handleChange}
    >
      <FormControlLabel value={"true"} control={<Radio />} label={labels[0]} />
      <FormControlLabel value={"false"} control={<Radio />} label={labels[1]} />
    </RadioGroup>
  )
};

export default BooleanOptions;